import { render, staticRenderFns } from "./StipendiatSborStories.vue?vue&type=template&id=3d1a6ac5&scoped=true&"
import script from "./StipendiatSborStories.vue?vue&type=script&lang=js&"
export * from "./StipendiatSborStories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1a6ac5",
  null
  
)

export default component.exports